import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = {
  key: 1,
  class: "mt-6 px-6"
}
const _hoisted_3 = {
  key: 0,
  class: "links pa-2"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "text-black font-weight-bold"
}
const _hoisted_7 = { key: 2 }

import { ref, onMounted, watch, computed } from 'vue';

import { getAllMatchupTables, getMatchupTableById } from '@/services/drUniversity/matchups/matchups.service';

import type { MatchupTableSummary, MatchupTableFull, MatchupCellResponse } from '@/services/drUniversity/matchups/matchups.model';

import liquipediaIcon from '@/assets/imgs/liquipedia.png';
import youtubeIcon from '@/assets/imgs/youtube.png';
import tiktokIcon from '@/assets/imgs/tiktok.png';
import soopIcon from '@/assets/imgs/soop.png';
import twitchIcon from '@/assets/imgs/twitch.png';
import instagramIcon from '@/assets/imgs/instagram.webp';
import twitterIcon from '@/assets/imgs/twitter.png';
import redditIcon from '@/assets/imgs/reddit.png';
import w3championsIcon from '@/assets/imgs/w3c.png';
import { getClassicWc3Races } from '@/services/wc3/wc3.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'DrUniversityMatchups',
  setup(__props) {

const platformIconMap: Record<string, string> = {
  tiktok: tiktokIcon,
  youtube: youtubeIcon,
  liquipedia: liquipediaIcon,
  soop: soopIcon,
  twitch: twitchIcon,
  instagram: instagramIcon,
  twitter: twitterIcon,
  reddit: redditIcon,
  w3champions: w3championsIcon,
};

const races = ref<{ id: number; name: string; short: string }[]>([]);

function createRaceShort(name: string) {
  const n = name.toLowerCase();

  if (n.includes('human')) return 'HU';
  if (n.includes('undead')) return 'UD';
  if (n.includes('orc')) return 'ORC';
  if (n.includes('night elf')) return 'NE';

  return name.substring(0, 2).toUpperCase();
}

const desiredOrder = ['HU', 'UD', 'ORC', 'NE'];
const tables = ref<MatchupTableSummary[]>([]);
const selectedIndex = ref(0);
const selectedTable = ref<MatchupTableFull | null>(null);
const loading = ref(true);

async function loadSelectedTable() {
  const table = tables.value[selectedIndex.value];
  if (!table) return;

  loading.value = true;
  selectedTable.value = await getMatchupTableById(table.id);
  loading.value = false;
}

onMounted(async () => {
  const raceData = await getClassicWc3Races();
  races.value = raceData.map((r) => ({
    ...r,
    short: createRaceShort(r.name),
  }));

  races.value.sort((a, b) => desiredOrder.indexOf(a.short) - desiredOrder.indexOf(b.short));

  tables.value = await getAllMatchupTables();

  if (tables.value.length > 0) {
    await loadSelectedTable();
  }
});

watch(selectedIndex, loadSelectedTable);

const grid = computed(() => {
  if (!selectedTable.value || races.value.length === 0) return [];

  const lookup = new Map<string, MatchupCellResponse>();

  selectedTable.value.cells.forEach((row) => {
    row.cols.forEach((col) => {
      const rowRace = races.value.find((r) => r.id === row.rowRaceId);
      const colRace = races.value.find((r) => r.id === col.colRaceId);

      if (!rowRace || !colRace) return;

      const key = `${rowRace.short}_${colRace.short}`;

      const fullCell: MatchupCellResponse = {
        cellId: col.cellId,
        rowRaceId: row.rowRaceId,
        rowRaceName: row.rowRaceName,
        colRaceId: col.colRaceId,
        colRaceName: col.colRaceName,
        links: col.links,
      };

      lookup.set(key, fullCell);
    });
  });

  return races.value.map((rowRace) =>
    races.value.map((colRace) => {
      const key = `${rowRace.short}_${colRace.short}`;
      return lookup.get(key) || null;
    })
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: selectedIndex.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIndex).value = $event)),
      dark: "",
      "align-tabs": "center"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tables.value, (t) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: t.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(t.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "d-flex mx-auto my-6"
        }))
      : (selectedTable.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_table, {
              class: "matchup-grid rounded-lg",
              density: "comfortable"
            }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(races.value, (race) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: race.id
                      }, _toDisplayString(race.short), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grid.value, (row, rIdx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: rIdx }, [
                      _createElementVNode("th", null, _toDisplayString(races.value[rIdx].short), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cIdx) => {
                        return (_openBlock(), _createElementBlock("td", { key: cIdx }, [
                          (cell && cell.links.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.links, (link) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "link-item",
                                    key: link.url
                                  }, [
                                    (link.platform && platformIconMap[link.platform])
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: platformIconMap[link.platform],
                                          class: "icon"
                                        }, null, 8, _hoisted_4))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("a", {
                                      href: link.url,
                                      target: "_blank"
                                    }, _toDisplayString(link.text || link.platform), 9, _hoisted_5)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, "—"))
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("h3", null, "No table loaded", -1)
          ]))]))
  ]))
}
}

})